// removed by extract-text-webpack-plugin
module.exports = {"List":"_1YcFyUQR_9sJIBXrqbozLv","rowgrid":"_2N94yTrJoVQyxsCpyCPQKZ","rowslider":"_3IihmSaCkMjoFr7pLd5Ack","sliderColumn":"ulNwY7HGtzCKG3j2qcZhC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/List/List.css
// module id = 299
// module chunks = 8